import gql from "graphql-tag";
import { cartItemFields, cartSupplyGroupFields } from "@/gql/cart.fragments";

export const saveCartMutation = gql`
  mutation saveCart($items: [CartItemInput]) {
    saveCart(items: $items) {
      inStockItems {
        ...CartItemFields
      }
      supplyGroups {
        ...CartSupplyGroupFields
      }
      sum {
        value
        currency {
          symbol
          code
        }
      }
    }
  }
  ${cartItemFields}
  ${cartSupplyGroupFields}
`;
